import PropTypes from "prop-types";
import get from "lodash/get";
import OfferInput from "./OfferInput.jsx";
import "./OfferList.scss";
import SingleOfferInput from "app/pages/PrePackage/SearchEngineOffers/SingleOfferInput";

const OfferList = ({
	offers = [],
	field,
	allAvailableDurations = [],
	productPriceValue,
	onOfferChange,
}) => {
	if (offers.length === 1) {
		return <SingleOfferInput offer={offers[0]} />;
	}

	return (
		<div className="offer-input__list">
			{offers.map(offer => {
				const offerType = get(offer, "pricing.type");
				return (
					<div key={offerType} className="offer-input__item">
						<OfferInput
							offer={offer}
							field={field}
							onChange={onOfferChange}
							data-testid={`search-engine-offer-${offerType}`}
							allAvailableDurations={allAvailableDurations}
							productPriceValue={productPriceValue}
						/>
					</div>
				);
			})}
		</div>
	);
};

OfferList.propTypes = {
	offers: PropTypes.array,
	field: PropTypes.object,
	productPriceValue: PropTypes.string,
	allAvailableDurations: PropTypes.arrayOf(PropTypes.number),
	onOfferChange: PropTypes.func,
};

export default OfferList;
